import { render, staticRenderFns } from "./SupplierSelectField.vue?vue&type=template&id=4e89e09e&"
import script from "./SupplierSelectField.vue?vue&type=script&lang=js&"
export * from "./SupplierSelectField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports